$component-class: 'cookie-type-1';

.#{$component-class} {
  position: fixed;
  bottom: var(--spacing-2xl);
  left: var(--spacing-lg);
  right: var(--spacing-lg);
  max-width: 1024px;
  margin: 0 auto;
  z-index: 50;
  background-color: var(--background-color-primary);
  pointer-events: none;
  opacity: 0;
  // Slide in with transform (composited, no layout shift) instead of animating `bottom`
  // (non-composited + counts toward CLS). Off-screen = pushed down by its own height plus
  // the bottom offset. Focus/a11y hiding is handled by the `inert` attribute (set in the
  // TSX when hidden), so no `visibility` toggle is needed — that toggle also made the
  // slotted me-buttons (transition: all) register a `visibility` animation.
  transform: translateY(calc(100% + var(--spacing-2xl)));
  transition:
    transform 0.4s ease,
    opacity 0.4s ease;

  &.is-visible {
    transform: translateY(0);
    pointer-events: auto;
    opacity: 1;
  }

  @include desktop {
    left: var(--spacing-2xl);
    right: var(--spacing-2xl);
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2xl);
    border: var(--border-size-sm) solid var(--border-color-primary);
    padding: var(--spacing-2xl) var(--spacing-4xl) var(--spacing-2xl) var(--spacing-xl);

    @include desktop {
      padding: var(--spacing-2xl) var(--spacing-5xl) var(--spacing-2xl) var(--spacing-4xl);
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
  }

  &__description {
    flex: 1;
  }

  &__description-wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
  }

  &__description-text {
    word-wrap: break-word;
    overflow-wrap: break-word;
    position: relative;
    display: block;

    &--collapsed {
      // Use line-clamp for precise 2-line truncation
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      word-break: break-word;
      text-overflow: clip;
      line-height: inherit;
      position: relative;

      // Apply to inner elements
      > p,
      > div {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        word-break: break-word;
        text-overflow: clip;
        line-height: inherit;
      }

      // Read-more link will be absolutely positioned via JavaScript
      .cookie-type-1__read-more-inline {
        position: absolute;
        bottom: 0;
        right: 0;
        white-space: nowrap;
        background-color: var(--background-color-primary, #fff);
        z-index: 1;

        // Ellipsis before link (no space, positioned right after text)
        .cookie-type-1__ellipsis-before {
          margin-right: 0;
        }

        // Link itself - small spacing (approximately one space)
        .cookie-type-1__read-more-link {
          margin-left: 0.3em;
        }
      }
    }
  }

  &__read-more-inline {
    display: inline;
    white-space: nowrap;
    vertical-align: baseline;
  }

  &__read-more-link {
    color: var(--color-link-primary, var(--color-primary));
    text-decoration: underline;
    cursor: pointer;
    font-size: inherit;
    font-family: inherit;
    background: none;
    border: none;
    padding: 0;
    display: inline;
    margin-left: 0.2em;

    &:hover {
      text-decoration: none;
    }

    &:focus {
      outline: 2px solid var(--color-focus, var(--color-primary));
      outline-offset: 2px;
    }
  }

  &__actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: var(--spacing-md);
    flex-wrap: wrap;
  }

  &__close {
    position: absolute;
    top: var(--spacing-sm);
    right: var(--spacing-sm);
    display: flex;
    justify-content: center;
    align-items: center;

    @include size(32px);

    @include desktop {
      top: var(--spacing-md);
      right: var(--spacing-md);
    }
  }
}
